var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M 20 0 C 9 0 0 9 0 20 C -2.3684758e-15 29.9 7.1992188 38.100781 16.699219 39.800781 L 16.820312 39.701172 C 16.813829 39.7 16.807265 39.700398 16.800781 39.699219 L 16.800781 25.599609 L 11.800781 25.599609 L 11.800781 20 L 16.800781 20 L 16.800781 15.599609 C 16.800781 10.599609 19.999609 7.8007812 24.599609 7.8007812 C 25.999609 7.8007812 27.6 7.9992187 29 8.1992188 L 29 13.300781 L 26.400391 13.300781 C 24.000391 13.300781 23.400391 14.499609 23.400391 16.099609 L 23.400391 20 L 28.699219 20 L 27.800781 25.599609 L 23.400391 25.599609 L 23.400391 39.699219 C 23.336643 39.710809 23.272732 39.713691 23.208984 39.724609 L 23.300781 39.800781 C 32.800781 38.100781 40 29.9 40 20 C 40 9 31 0 20 0 z ",
    style: {
      fill: "#ffffff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.600bb66a5227375ae3b1ace57f53ff27.svg";
export { ForwardRef as ReactComponent };